export default __webpack_public_path__ + "9f9204cabecb9f8257b0b3757bb8e5c4.png";